module.exports = __webpack_public_path__ + "img/bg-map.8a3f4bc1.png";